import React from 'react';
import AdrCodePreview from '../adr-code-preview/adr-code-preview.jsx';
import adrCodeService from '../../services/web/adr-code-service.js';

function AdrCodeCellRenderer({ value }) {
    return <AdrCodePreview code={adrCodeService.formatAdrCode(value)} width={65} showLabel={false} />;
}

export default AdrCodeCellRenderer;
